import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { JSONGeneratorHistoryElectricityCreate, JSONGeneratorHistoryElectricityGet, JSONGeneratorHistoryGasCreate, JSONGeneratorHistoryGasGet } from '../interfaces/admin-interfaces';
import { API_ROUTES } from './api-routes';
import { DEFAULT_JSON_HEADERS } from './headers.config';

@Injectable({
  providedIn: 'root'
})
export class AdminService {
  constructor(private http: HttpClient) { }

  createElectricityJsonRecord(data: JSONGeneratorHistoryElectricityCreate): Observable<any> {
    const payload = JSON.stringify(data);

    return this.http.post<JSONGeneratorHistoryElectricityGet>(
      `${API_ROUTES.ADMIN.JSON_GENERATOR_ELECTRICITY}`,
      payload,
      { headers: DEFAULT_JSON_HEADERS }
    );
  }

  createGasJsonRecord(data: JSONGeneratorHistoryGasCreate): Observable<any> {
    const payload = JSON.stringify(data);

    return this.http.post<JSONGeneratorHistoryGasGet>(
      `${API_ROUTES.ADMIN.JSON_GENERATOR_GAS}`,
      payload,
      { headers: DEFAULT_JSON_HEADERS }
    );
  }

  updateElectricityJsonRecord(id: string, data: JSONGeneratorHistoryElectricityCreate): Observable<any> {
    const payload = JSON.parse(JSON.stringify(data));

    return this.http.post<JSONGeneratorHistoryElectricityGet>(
      `${API_ROUTES.ADMIN.JSON_GENERATOR_ELECTRICITY}/${id}`,
      payload,
    );
  }

  updateGasJsonRecord(id: string, data: JSONGeneratorHistoryGasCreate): Observable<any> {
    const payload = JSON.parse(JSON.stringify(data));

    return this.http.post<JSONGeneratorHistoryGasGet>(
      `${API_ROUTES.ADMIN.JSON_GENERATOR_GAS}/${id}`,
      payload,
    );
  }

  deleteElectricityJsonRecord(id: string): Observable<any> {
    return this.http.delete<any>(
      `${API_ROUTES.ADMIN.JSON_GENERATOR_ELECTRICITY}/${id}`,
    );
  }

  deleteGasJsonRecord(id: string): Observable<any> {
    return this.http.delete<any>(
      `${API_ROUTES.ADMIN.JSON_GENERATOR_GAS}/${id}`,
    );
  }

  getElectricityJsonRecords(next_page: number = 1, per_page: number = 20): Observable<any> {
    const params = new HttpParams()
      .set('next_page', next_page)
      .set('per_page', per_page);

    return this.http.get<any>(
      API_ROUTES.ADMIN.JSON_GENERATOR_ELECTRICITY,
      { params: params, observe: 'response' }
    ).pipe(
      map(response => {
        const totalCount = response.headers?.get('x-total-count') ? Number(response.headers.get('x-total-count')) : 0;
        return { data: response.body.data || [], totalCount: totalCount };
      }));
  }

  getGasJsonRecords(next_page: number = 1, per_page: number = 20): Observable<any> {
    const params = new HttpParams()
      .set('next_page', next_page)
      .set('per_page', per_page);

    return this.http.get<any>(
      API_ROUTES.ADMIN.JSON_GENERATOR_GAS,
      { params: params, observe: 'response' }
    ).pipe(
      map(response => {
        const totalCount = response.headers?.get('x-total-count') ? Number(response.headers.get('x-total-count')) : 0;
        return { data: response.body.data || [], totalCount: totalCount };
      }));
  }

  uploadElectricityJsonRecord(file: File): Observable<any> {
    const formData = new FormData();
    formData.append("file", file);

    return this.http.post<any>(
      `${API_ROUTES.ADMIN.JSON_GENERATOR_ELECTRICITY}/upload/`,
      formData,
    );
  }

  uploadGasJsonRecord(file: File): Observable<any> {
    const formData = new FormData();
    formData.append("file", file);

    return this.http.post<any>(
      `${API_ROUTES.ADMIN.JSON_GENERATOR_GAS}/upload/`,
      formData,
    );
  }

  // File Extraction
  getFileExtractionHistory(next_page: number = 1, per_page: number = 20): Observable<any> {
    const params = new HttpParams()
      .set('next_page', next_page)
      .set('per_page', per_page);

    return this.http.get<any>(
      API_ROUTES.ADMIN.EXTRACTION_HISTORY,
      { params: params, observe: 'response' }
    ).pipe(
      map(response => {
        const totalCount = response.headers?.get('x-total-count') ? Number(response.headers.get('x-total-count')) : 0;
        return { data: response.body.data || [], totalCount: totalCount };
      }));
  }

  uploadFileForExtraction(file: File): Observable<any> {
    const formData = new FormData();
    formData.append("file", file);

    return this.http.post<any>(
      `${API_ROUTES.ADMIN.EXTRACTION}/upload`,
      formData,
    );
  }

  getExtractionEventLogs(id: string): Observable<any> {
    const payload = {};

    return this.http.get<any>(
      `${API_ROUTES.ADMIN.EXTRACTION}/${id}/logs`,
      payload,
    );
  }
}
